import { formatInTz, localDateOf } from '@zibanu/shared';

const WEEKDAY = new Intl.DateTimeFormat('en-GB', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' });

/** "Mon 12 Oct" for a business date (YYYY-MM-DD) — the design system's day-first style. */
export function dayLabel(date: string): string {
  return WEEKDAY.format(new Date(`${date}T00:00:00Z`)).replace(',', '');
}

/** "Today", "Yesterday", or "Mon 12 Oct" — Records' day headings. */
export function dayHeading(date: string, today: string, words: { today: string; yesterday: string }): string {
  if (date === today) return words.today;
  const y = new Date(`${today}T00:00:00Z`);
  y.setUTCDate(y.getUTCDate() - 1);
  if (date === y.toISOString().slice(0, 10)) return words.yesterday;
  return dayLabel(date);
}

/** "2:14 pm" in the books' timezone. */
export function timeOf(iso: string, timezone: string): string {
  return new Intl.DateTimeFormat('en-GB', { hour: 'numeric', minute: '2-digit', hour12: true, timeZone: timezone })
    .format(new Date(iso))
    .replace(/\s?([ap])\.?m\.?/i, ' $1m')
    .toLowerCase();
}

/** "12 Mar 2026, 4:15 PM" — kept for alerts' longer timestamps. */
export const whenLong = (iso: string, timezone: string) => formatInTz(new Date(iso), timezone);
/** "2:14 pm" today, "Mon 12 Oct, 2:14 pm" before: when something happened, in the books' timezone. */
export function stamp(iso: string, timezone: string, today: string): string {
  const date = localDateOf(new Date(iso), timezone);
  return date === today ? timeOf(iso, timezone) : `${dayLabel(date)}, ${timeOf(iso, timezone)}`;
}

/** The business date before this one. */
export function dayBefore(date: string): string {
  const d = new Date(`${date}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() - 1);
  return d.toISOString().slice(0, 10);
}

const MONTH = new Intl.DateTimeFormat('en-GB', { month: 'long', timeZone: 'UTC' });

/** "August" for a business date: "a customer since August". */
export function monthName(date: string): string {
  return MONTH.format(new Date(`${date}T00:00:00Z`));
}
